/* tslint:disable:no-bitwise */

// https://stackoverflow.com/a/2117523
function basicUuidv4() {
  const cryptoLib =  window.crypto || (window as any).msCrypto;
  // @ts-ignore
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ cryptoLib.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

function cartClientId() {
  return basicUuidv4() + new Date().toISOString().split('T')[0];
}

export const cryptoHelper = {
  basicUuidv4,
  cartClientId,
};
